import {
  TCoreAction,
  EModalActionTypes,
  IDialogProps,
  TModalKey,
  IModalProps,
  TModalesActions,
  IBaseModalProps,
  TOmitOnClose,
} from '@/store/types/modals.types';

export function openModal<T extends IBaseModalProps>(
  keyModal: TModalKey,
  props?: TOmitOnClose<IModalProps<T>['props']> & { onClose?: (arg?: any) => void },
  dialogProps?: IDialogProps,
): TCoreAction {
  return {
    type: EModalActionTypes.OPEN_MODAL,
    keyModal,
    props,
    dialogProps,
  };
}

export const closeModal = (action?: keyof typeof TModalesActions): TCoreAction => ({
  type: EModalActionTypes.CLOSE_MODAL,
  action,
});
